import { CircleCheck } from 'generated/icons';
import React from 'react';
import Text from '../Text';

interface Props {
  permissions: string[];
}

export function PermissionsList({ permissions }: Props) {
  return (
    <div className="bg-light-selected-faint dark:bg-dark-hover-faint border border-control rounded-[10px] w-full">
      {permissions.map((permission, i) => (
        <div
          key={`${permission}-${i}`}
          className={`flex gap-[10px] items-center p-[15px]${
            i < permissions.length - 1 ? ' border-b border-control' : ''
          }`}
        >
          <CircleCheck className="text-alert-success shrink-0" />
          <Text variant="base">{permission}</Text>
        </div>
      ))}
    </div>
  );
}
